<template>
  <q-dialog
    v-model="shown"
  >
    <q-card
      v-if="order"
      style="min-width: 50%;"
    >
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Email Items
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <model-table
          :collection="order.orderItems"
          selection="multiple"
          :columns="[
            { field: 'id' },
            { field: 'type', component: OrderItemTypeCell },
            { field: 'state', component: OrderStateCell },
            { field: 'description', maxWidth: '250px' },
            { field: 'total', component: 'money' }
          ]"
          :cell-class="props => classesForRow(props.row)"
          :show-add="false"
          :show-edit="false"
          row-key="id"
          :initial-selection="selected"
          :filter-by-data-array="selectableOrderItems"
          @selected-input="selectedUpdate => selected = selectedUpdate"
        />
      </q-card-section>
      <q-card-actions
        class="row q-gutter-sm justify-end q-ma-sm items-start"
      >
        <q-btn
          color="primary"
          :disable="validSelection.length === 0"
          :loading="emailing"
          @click="emailItems"
        >
          Email ({{ validSelection.length }} item{{ validSelection.length === 1 ? '' : 's' }})
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ORDER_ITEM_TYPES } from 'src/models/order-item/OrderItem'
import ModelTable from 'src/modules/admin/components/ModelTable'
import OrderItemTypeCell from 'src/modules/admin/order/components/OrderItemTypeCell'
import OrderStateCell from 'src/modules/admin/order/components/OrderStateCell'

export default {
  name: 'EmailItemsDialog',
  components: {
    ModelTable
  },
  emits: ['update:model-value', 'email-success'],
  data () {
    return {
      order: null,
      shown: false,
      email: '',
      selected: [],
      emailing: false
    }
  },
  computed: {
    validSelection () {
      return _.filter(this.selected, orderItem => orderItem.placed || orderItem.paid)
    },
    selectableOrderItems () {
      return _.filter(this.order.orderItems.data, orderItem =>
        _.includes(ORDER_ITEM_TYPES.REQUIRES_EMAIL, orderItem.type)
      )
    }
  },
  configuration: ['currentCircuit', 'currentSite'],
  watch: {
    selected () {
      const validSelectedItems = _.intersection(this.selected, this.selectableOrderItems)
      if (_.difference(this.selected, validSelectedItems).length) {
        this.selected = _.intersection(this.selected, validSelectedItems)
      }
    },
    shown () {
      this.$emit('update:model-value', this.shown)

      // Cleanup data
      if (!this.shown) {
        this.order = null
        this.email = ''
      }
    }
  },
  created () {
    _.extend(this, {
      OrderItemTypeCell,
      OrderStateCell
    })
  },
  methods: {
    show (order, email) {
      this.order = order
      this.selected = _.filter(this.order.orderItems.data, orderItem =>
        _.includes(ORDER_ITEM_TYPES.REQUIRES_EMAIL, orderItem.type)
      )
      this.email = email
      this.shown = true
    },
    classesForRow (orderItem) {
      if (orderItem.state === 'placed' || orderItem.state === 'paid') {
        return []
      } else if (orderItem.state === 'voided') {
        return ['tr-bg-grey-5', 'bg-grey-5']
      } else if (orderItem.state === 'draft') {
        return ['tr-bg-grey-4', 'bg-grey-4']
      } else {
        throw new Error('Unhandled Condition')
      }
    },
    async emailItems () {
      this.emailing = true

      await this.order.emailItems(this.email, _.map(this.selected, 'id'))
      await this.order.fetch(true)

      this.emailing = false
      this.$emit('email-success')

      this.shown = false
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.tr-bg-grey-4) {
  background: #DDD;
}
:deep(.tr-bg-grey-5) {
  background: #BDBDBD;
}
</style>
